
const flagsMap: Record<string, string> = {
  AD: '/assets/img/flags/AD.png',
  AE: '/assets/img/flags/AE.png',
  AF: '/assets/img/flags/AF.png',
  AL: '/assets/img/flags/AL.png',
  AM: '/assets/img/flags/AM.png',
  AO: '/assets/img/flags/AO.png',
  AR: '/assets/img/flags/AR.png',
  AT: '/assets/img/flags/AT.svg', // svg preferred over png
  AU: '/assets/img/flags/AU.png',
  AZ: '/assets/img/flags/AZ.png',
  BA: '/assets/img/flags/BA.png',
  BD: '/assets/img/flags/BD.png',
  BE: '/assets/img/flags/be.png',
  BG: '/assets/img/flags/BG.png',
  BR: '/assets/img/flags/BR.png',
  BY: '/assets/img/flags/BY.png',
  CA: '/assets/img/flags/CA.png',
  CD: '/assets/img/flags/CD.png',
  CH: '/assets/img/flags/CH.png',
  CI: '/assets/img/flags/CI.png',
  CL: '/assets/img/flags/CL.png',
  CN: '/assets/img/flags/CN.png',
  CO: '/assets/img/flags/CO.png',
  CR: '/assets/img/flags/CR.png',
  CU: '/assets/img/flags/CU.png',
  CY: '/assets/img/flags/CY.png',
  CZ: '/assets/img/flags/cz.png',
  D: '/assets/img/flags/D.png',
  DE: '/assets/img/flags/de.png',
  DK: '/assets/img/flags/DK.png',
  DZ: '/assets/img/flags/DZ.png',
  E: '/assets/img/flags/E.png',
  EC: '/assets/img/flags/EC.png',
  EE: '/assets/img/flags/EE.png',
  EG: '/assets/img/flags/EG.png',
  EMPTY: '/assets/img/flags/EMPTY.png',
  EN: '/assets/img/flags/EN.png',
  ES: '/assets/img/flags/ES.png',
  ET: '/assets/img/flags/ET.png',
  EU: '/assets/img/flags/EU.png',
  F: '/assets/img/flags/F.png',
  FI: '/assets/img/flags/FI.png',
  FR: '/assets/img/flags/fr.png',
  GE: '/assets/img/flags/GE.png',
  GR: '/assets/img/flags/GR.png',
  HR: '/assets/img/flags/HR.png',
  HU: '/assets/img/flags/HU.png',
  ID: '/assets/img/flags/ID.png',
  IE: '/assets/img/flags/IE.png',
  IL: '/assets/img/flags/IL.png',
  IN: '/assets/img/flags/IN.png',
  IQ: '/assets/img/flags/IQ.png',
  IR: '/assets/img/flags/IR.png',
  IS: '/assets/img/flags/IS.png',
  IT: '/assets/img/flags/IT.png',
  JO: '/assets/img/flags/JO.png',
  JP: '/assets/img/flags/JP.png',
  KE: '/assets/img/flags/KE.png',
  KG: '/assets/img/flags/KG.png',
  KH: '/assets/img/flags/KH.png',
  KP: '/assets/img/flags/KP.png',
  KR: '/assets/img/flags/KR.png',
  KW: '/assets/img/flags/KW.png',
  KZ: '/assets/img/flags/KZ.png',
  LA: '/assets/img/flags/LA.png',
  LB: '/assets/img/flags/LB.png',
  LI: '/assets/img/flags/LI.png',
  LT: '/assets/img/flags/LT.png',
  LU: '/assets/img/flags/LU.png',
  LV: '/assets/img/flags/LV.png',
  LY: '/assets/img/flags/LY.png',
  MA: '/assets/img/flags/MA.png',
  MC: '/assets/img/flags/MC.png',
  MD: '/assets/img/flags/MD.png',
  ME: '/assets/img/flags/ME.png',
  MK: '/assets/img/flags/MK.png',
  MN: '/assets/img/flags/MN.png',
  MT: '/assets/img/flags/MT.png',
  MX: '/assets/img/flags/MX.png',
  MY: '/assets/img/flags/MY.png',
  NG: '/assets/img/flags/NG.png',
  NL: '/assets/img/flags/NL.png',
  NO: '/assets/img/flags/NO.png',
  NZ: '/assets/img/flags/NZ.png',
  OM: '/assets/img/flags/OM.png',
  PA: '/assets/img/flags/PA.png',
  PE: '/assets/img/flags/PE.png',
  PK: '/assets/img/flags/PK.png',
  PL: '/assets/img/flags/PL.png',
  PS: '/assets/img/flags/PS.png',
  PT: '/assets/img/flags/PT.png',
  QA: '/assets/img/flags/QA.png',
  RO: '/assets/img/flags/RO.png',
  RU: '/assets/img/flags/ru.png',
  SA: '/assets/img/flags/SA.png',
  SE: '/assets/img/flags/SE.png',
  SG: '/assets/img/flags/SG.png',
  SI: '/assets/img/flags/SI.png',
  SK: '/assets/img/flags/SK.png',
  SM: '/assets/img/flags/SM.png',
  SN: '/assets/img/flags/SN.png',
  SY: '/assets/img/flags/SY.png',
  TH: '/assets/img/flags/TH.png',
  TJ: '/assets/img/flags/TJ.png',
  TM: '/assets/img/flags/TM.png',
  TN: '/assets/img/flags/TN.png',
  TR: '/assets/img/flags/TR.png',
  TZ: '/assets/img/flags/TZ.png',
  UA: '/assets/img/flags/ua.png',
  UNKNOWN: '/assets/img/flags/Unknown.png',
  US: '/assets/img/flags/US.png',
  UY: '/assets/img/flags/UY.png',
  UZ: '/assets/img/flags/UZ.png',
  VE: '/assets/img/flags/VE.png',
  VN: '/assets/img/flags/VN.png',
  XS: '/assets/img/flags/XS.png',
  YE: '/assets/img/flags/YE.png',
  ZA: '/assets/img/flags/ZA.png',
  ZW: '/assets/img/flags/ZW.png',

  // Tachograph nation codes
  A: '/assets/img/flags/AT.svg', // Austria
  AND: '/assets/img/flags/AD.png', // Andorra
  ARM: '/assets/img/flags/AM.png', // Armenia
  B: '/assets/img/flags/be.png', // Belgium
  BIH: '/assets/img/flags/BA.png', // Bosnia and Herzegovina
  EST: '/assets/img/flags/EE.png', // Estonia
  FIN: '/assets/img/flags/FI.png', // Finland
  FL: '/assets/img/flags/LI.png', // Liechtenstein
  H: '/assets/img/flags/HU.png', // Hungary
  I: '/assets/img/flags/IT.png', // Italy
  IRL: '/assets/img/flags/IE.png', // Ireland
  L: '/assets/img/flags/LU.png', // Luxembourg
  M: '/assets/img/flags/MT.png', // Malta
  MNE: '/assets/img/flags/ME.png', // Montenegro
  N: '/assets/img/flags/NO.png', // Norway
  P: '/assets/img/flags/PT.png', // Portugal
  RSM: '/assets/img/flags/SM.png', // San Marino
  RUS: '/assets/img/flags/ru.png', // Russia
  S: '/assets/img/flags/SE.png', // Sweden
  SLO: '/assets/img/flags/SI.png', // Slovenia
  UK: '/assets/img/flags/EN.png', // United Kingdom
}

export type CountryCode = keyof typeof flagsMap

// Root-absolute paths resolve against the web app's origin. The chart-renderer
// service opens the bundle over file://, where there is no origin - it sets
// __ASSET_BASE__ to the bundle directory so the flags still load.
const withAssetBase = (path: string): string => {
  if (!path) return path
  const base =
    typeof window !== 'undefined' ? (window as any).__ASSET_BASE__ : undefined
  return base ? `${base}${path.replace(/^\//, '')}` : path
}

export const getCountryFlagStrict = (code: CountryCode): string => {
  return withAssetBase(flagsMap[code])
}

export const getCountryFlag = (code?: string | null) => {
  const upper = code?.trim().toUpperCase()
  if (!upper) return withAssetBase(flagsMap.UNKNOWN ?? flagsMap.EMPTY ?? '')
  const normalized = upper === 'GB' ? 'EN' : upper
  return withAssetBase(
    flagsMap[normalized] ?? flagsMap.UNKNOWN ?? flagsMap.EMPTY ?? '',
  )
}
